
// src/actions/preserved-queries.js

import api from './gamba-api'
import { emitAlertMessage, clearAlertMessage } from './alert-message'

export const FETCH_PRESERVED_QUERIES = "FETCH_PRESERVED_QUERIES"
export const FETCH_PRESERVED_QUERIES_REQUESTED = "FETCH_PRESERVED_QUERIES_REQUESTED"
export const FETCH_PRESERVED_QUERIES_COMPLETED = "FETCH_PRESERVED_QUERIES_COMPLETED"
export const FETCH_PRESERVED_QUERIES_FAILED = "FETCH_PRESERVED_QUERIES_FAILED"

export function fetchPreservedQueriesRequested() {
  return {
    type: FETCH_PRESERVED_QUERIES_REQUESTED
  }
}

export function fetchPreservedQueries(group_id = undefined) {
  return function(dispatch) {
    dispatch(fetchPreservedQueriesRequested())
    return api.get(`/preserved_queries`, group_id && { group_id } || {})
        .then((results)=> {
          dispatch(fetchPreservedQueriesCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchPreservedQueriesFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchPreservedQueriesCompleted(results) {
  return {
    type: FETCH_PRESERVED_QUERIES_COMPLETED,
    results,
  }
}

export function fetchPreservedQueriesFailed(error) {
  return {
    type: FETCH_PRESERVED_QUERIES_FAILED,
    error,
  }
}

export const CREATE_PRESERVED_QUERY = "CREATE_PRESERVED_QUERY"
export const CREATE_PRESERVED_QUERY_REQUESTED = "CREATE_PRESERVED_QUERY_REQUESTED"
export const CREATE_PRESERVED_QUERY_COMPLETED = "CREATE_PRESERVED_QUERY_COMPLETED"
export const CREATE_PRESERVED_QUERY_FAILED = "CREATE_PRESERVED_QUERY_FAILED"

export function createPreservedQueryRequested() {
  return {
    type: CREATE_PRESERVED_QUERY_REQUESTED
  }
}

export function createPreservedQuery(name, query_text, group_id = undefined) {
  return function(dispatch) {
    dispatch(createPreservedQueryRequested())
    return api.post(`/preserved_queries`, { name, query_text, group_id })
        .then((results)=> {
          dispatch(createPreservedQueryCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(createPreservedQueryFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function createPreservedQueryCompleted(results) {
  return {
    type: CREATE_PRESERVED_QUERY_COMPLETED,
    results,
  }
}

export function createPreservedQueryFailed(error) {
  return {
    type: CREATE_PRESERVED_QUERY_FAILED,
    error,
  }
}

export const DELETE_PRESERVED_QUERY = "DELETE_PRESERVED_QUERY"
export const DELETE_PRESERVED_QUERY_REQUESTED = "DELETE_PRESERVED_QUERY_REQUESTED"
export const DELETE_PRESERVED_QUERY_COMPLETED = "DELETE_PRESERVED_QUERY_COMPLETED"
export const DELETE_PRESERVED_QUERY_FAILED = "DELETE_PRESERVED_QUERY_FAILED"

export function deletePreservedQueryRequested() {
  return {
    type: DELETE_PRESERVED_QUERY_REQUESTED
  }
}

export function deletePreservedQuery(query_id) {
  return function(dispatch) {
    dispatch(deletePreservedQueryRequested())
    return api.delete(`/preserved_queries/${query_id}`)
        .then((results)=> {
          dispatch(deletePreservedQueryCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(deletePreservedQueryFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function deletePreservedQueryCompleted(results) {
  return {
    type: DELETE_PRESERVED_QUERY_COMPLETED,
    results,
  }
}

export function deletePreservedQueryFailed(error) {
  return {
    type: DELETE_PRESERVED_QUERY_FAILED,
    error,
  }
}

export const CLEAR_PRESERVED_QUERIES = "CLEAR_PRESERVED_QUERIES"

export function clearPreservedQueries() {
  return {
    type: CLEAR_PRESERVED_QUERIES,
  }
}



// WEBPACK FOOTER //
// ./src/actions/preserved-queries.js